<template>
    <div :class="['game-player', currentPlayer ? 'active shadow-active' : 'inactive shadow-inactive', playercount > 2 ? 'morethantwo' : '']">
        <div :class="['game-player-name', showCPUBar ? 'cpu' : '']">
            <i class="fas fa-circle" v-if="startPlayer"></i>
            {{name}}
        </div>
        <div class="game-player-score">{{scoreOverride ? scoreOverride : score}}</div>
        <!-- <div class="game-player-score-before">{{lastscore}}</div> -->
        <div class="game-player-thrown">{{fullscore_sum}}</div>
        <div class="game-player-sets">
            <div class="game-player-label">{{__('games.sets')}}</div>
            <div class="game-player-value">{{sets}}/{{maxsets}}</div>
        </div>
        <div class="game-player-legs">
            <div class="game-player-label">{{__('games.legs')}}</div>
            <div class="game-player-value">{{legs}}/{{maxlegs}}</div>
        </div>
        <div class="game-player-avg">
            <div class="game-player-label">{{__('games.avg3')}}</div>
            <div class="game-player-value">{{avg3}}</div>
        </div>
        <div class="game-player-darts">
            <div class="game-player-label">{{__('games.darts')}}</div>
            <div class="game-player-value">{{dartcount}}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        'playerIndex',
        'playerId',
        'smallscores',
        'currentOnly',
        'scoreOverride',
        'playercount'
    ],
    data() {
        return {
            winner: false,
            loser: false,
            name: '',
            score: 0,
            fullscore_sum: 0,
            lastscore: 0,
            currentPlayer: false,
            startPlayer: false,
            singlescores: [],
            avg3: 0,
            avg1: 0,
            dartcount: 0,
            showCPUBar: false,
            legs: 0,
            sets: 0,
            maxlegs: 0,
            maxsets: 0,
            roundEnd: false,
            scoreModifier: 0,
            backupScore: 0,
        }
    },
    mounted() {
        window.connection.subscribe(this);
        this.update(window.connection.lastUpdate);

        this.$root.$on('numpad-modify-currentscore', (score, fullscore) => {
            if (this.currentPlayer) {
                this.score = this.backupScore;
                this.score += parseInt(score);
                this.fullscore_sum = fullscore;
            }
        })
    },

    methods: {
        update(data) {
            this.name = data.gameState.scores[this.playerIndex].name;
            this.score = data.gameState.scores[this.playerIndex].score;
            this.backupScore = this.score;
            this.fullscore_sum = data.gameState.scores[this.playerIndex].fullscore_sum;
            this.lastscore = data.gameState.scores[this.playerIndex].lastscore;
            this.singlescores = data.gameState.scores[this.playerIndex].singlescores;
            this.currentPlayer = data.gameState.currentPlayer == this.playerId;
            this.startPlayer = data.gameState.throws.startPlayer == this.playerId;

            this.winner = data.gameState.winner == this.playerId;
            this.loser = data.gameState.winner && data.gameState.winner != this.playerId;

            if (data.gameState.scores[this.playerIndex].stats) {
                this.avg3 = data.gameState.scores[this.playerIndex].stats.avg3.toFixed(2);
                this.avg1 = data.gameState.scores[this.playerIndex].stats.avg1.toFixed(2);
                this.dartcount = data.gameState.scores[this.playerIndex].stats.dartcount;
            }

            //sets and legs
            if (data.setState) {
                this.legs = data.setState["legs_player" + (this.playerIndex + 1)];
                this.sets = data.setState["sets_player" + (this.playerIndex + 1)];
                this.maxsets = data.setState["max_sets"];
                this.maxlegs = data.setState["max_legs"];
            }

            //cpu bar update
            if (data.gameState && this.currentPlayer && data.gameState.currentUserType == "computer") {
                this.showCPUBar = true;
                var cpuplayer = data.gameState.scores[data.gameState.currentPlayerIndex];
                document.documentElement.style.setProperty('--cputimer', cpuplayer.nextplayertime + 's');
            } else {
                this.showCPUBar = false;
            }

            //reset fullscore sum on next player in 1 player game
            if (data.action == "nextPlayer" && data.gameState.scores.length == 1) {
                this.fullscore_sum = 0;
                this.singlescores = [];
            }

            //show hide end of round overlay
            this.roundEnd = data.action == "playerInputSingle" && this.singlescores && this.singlescores.length == 3 && this.currentPlayer;
        },
        singlescore(num) {
            if (this.singlescores) {
                if (this.singlescores[num - 1] && this.singlescores[num - 1]['str'] !== undefined)
                    return this.singlescores[num - 1]['str'];
                else
                    return this.singlescores[num - 1];
            }
            return "";
        },
        colorCheck(data, number) {
            if (!data) return;
            if (data[number] !== undefined && data[number].success) return "success";
            if (data[number] !== undefined && data[number].missed === false) return "success";
            if (data[number] !== undefined && data[number].missed) return "miss";
            if (data[number] === undefined) return "open";
        },
    }

}
</script>
